import Box from '@mui/material/Box';
import React, { CSSProperties } from 'react';

import useStyles from './StagingTypeChip.style';

interface StagingTypeChipProps {
  stagingType?: guesthouse.onboarding.CheckoutOption;
  className?: string;
  style?: CSSProperties;
}

const textOptions = {
  'full_staging': {
    text: 'Full Staging',
    color: '#E3F1D1'
  },
  'freshen_online': {
    text: 'Freshen Online',
    color: '#D3E0E2'
  },
  'freshen_in_person': {
    text: 'Freshen In Person',
    color: '#E0BFB0'
  },
};

const StagingTypeChip: React.FC<StagingTypeChipProps> = (props) => {
  const { stagingType, className, style } = props;
  const { classes, cx } = useStyles();

  if (stagingType && textOptions[stagingType]) {
    return (
      <div
        className={cx(classes.chipWrapper, className)}
        style={{
          backgroundColor: textOptions[stagingType].color,
          ...style
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          className={classes.chipText}
        >
          {textOptions[stagingType].text}
        </Box>
      </div>
    );
  }

  return null;
};

StagingTypeChip.defaultProps = {
  style: {},
};

export default StagingTypeChip;
